export default "__VITE_ASSET__CmIqv0mQ__"